
import React from 'react';
import AIGeneratedImage from './AIGeneratedImage';

const About: React.FC = () => {
  return (
    <section id="about" className="py-40 relative scroll-mt-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-32 items-center">
          
          <div className="relative order-2 lg:order-1 group">
            <div className="absolute -top-20 -left-20 w-64 h-64 bg-brand-500/10 blur-[120px] rounded-full animate-pulse" />
            <div className="relative glass-premium p-5 rounded-[3rem] border-white/5 overflow-hidden">
              <div className="hologram-line" />
              <div className="overflow-hidden rounded-[2.5rem] aspect-[4/5] relative">
                <AIGeneratedImage 
                  prompt="A hyper-realistic cinematic visualization of a global digital shield protecting planet earth from purple solar flares, futuristic holographic UI elements, deep cyan and neon accents"
                  alt="Astra Neural Shield"
                  aspectRatio="3:4"
                  className="w-full h-full"
                />
                <div className="absolute bottom-12 left-12 right-12 space-y-3 z-20">
                  <div className="text-[10px] font-black text-brand-400 font-mono tracking-[0.4em] uppercase">SYSTEM ANALYTICS</div>
                  <div className="text-3xl font-extrabold leading-tight text-white tracking-tighter">Unified Secure Intelligence Across the Void.</div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-16 order-1 lg:order-2">
            <div className="space-y-8">
              <h2 className="text-[11px] font-black text-brand-400 font-mono tracking-[0.5em] uppercase">ASTRA PHILOSOPHY</h2>
              <h3 className="text-5xl md:text-7xl font-extrabold text-white leading-[1] tracking-tighter">
                Architecture <br />
                <span className="text-brand-400">Beyond</span> Boundaries.
              </h3>
              <p className="text-xl text-slate-400 leading-relaxed font-light">
                We design digital citadels for the cosmic era. At Sentrix Astra, we believe security is the universal constant—the immutable force that allows intelligence to flourish in any environment.
              </p>
            </div>
            
            <div className="space-y-10">
              <div className="flex gap-8 items-start group">
                <div className="w-16 h-16 rounded-[1.5rem] bg-white/5 border border-white/10 flex items-center justify-center shrink-0 group-hover:bg-brand-500 transition-all duration-700 shadow-xl group-hover:shadow-brand-500/20">
                  <span className="text-2xl font-black text-brand-400 group-hover:text-white font-mono">01</span>
                </div>
                <div className="space-y-3">
                  <h4 className="text-xl font-black text-white uppercase tracking-tight">COSMIC-SCALE RESILIENCE</h4>
                  <p className="text-base text-slate-400 leading-relaxed font-light">Systems that endure beyond planetary localized threats, providing continuous coverage and sub-millisecond response globally.</p>
                </div>
              </div>
              <div className="flex gap-8 items-start group">
                <div className="w-16 h-16 rounded-[1.5rem] bg-white/5 border border-white/10 flex items-center justify-center shrink-0 group-hover:bg-brand-500 transition-all duration-700 shadow-xl group-hover:shadow-brand-500/20">
                  <span className="text-2xl font-black text-brand-400 group-hover:text-white font-mono">02</span>
                </div>
                <div className="space-y-3">
                  <h4 className="text-xl font-black text-white uppercase tracking-tight">AUTONOMOUS ETHICAL CORES</h4>
                  <p className="text-base text-slate-400 leading-relaxed font-light">Self-healing security kernels driven by verifiable AI logic, ensuring integrity from the deep code to the edge interface.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
